import { useParams } from 'react-router-dom';
import EditInventaire from '@repo/ui/features/inventaires/arbre/edit/index';

export default function ArbreEditPage() {
  const { id = '' } = useParams<{ id?: string }>();

  return (
    <div className="w-full py-6">
      <EditInventaire inventaireId={Number(id)} />
    </div>
  );
}
